import { rpcCall, rpcClearAuth } from "./rpc";
import { DefaultFreightSearchFilters, DefaultUserSettings } from "../models/user";
let currentUser;
let lastRefreshDate;
export function isLoggedIn() {
    return currentUser != null;
}
export function getCurrentUser() {
    if (currentUser) {
        if (!currentUser.settings) {
            currentUser.settings = DefaultUserSettings();
        }
        if (!currentUser.settings.freightSearchFilters) {
            currentUser.settings.freightSearchFilters = DefaultFreightSearchFilters();
        }
    }
    return currentUser;
}
export async function setColumns(cols = '') {
    try {
        return await rpcCall("updateColumns", cols);
    }
    catch (e) {
        console.log(e);
    }
}
// export async function updateUserFilters(userFilters: UserFilters) {
//     return await rpcCall("updateUserFilters", userFilters)
// }
export async function updateUserSettings(settings) {
    if (!currentUser) {
        return;
    }
    try {
        await rpcCall("updateUserSettings", settings);
        currentUser.settings = settings;
    }
    catch (e) {
        console.log(e);
    }
}
export async function authEmail(email = '', firstName = '', lastName = '') {
    let requestJson = {
        "email": email,
        "firstName": firstName,
        "lastName": lastName,
    };
    try {
        let response = await rpcCall("auth.email", requestJson);
        currentUser = {
            id: response['id'],
            email: email,
            firstName: firstName,
            lastName: lastName,
        };
    }
    catch (e) {
        console.log(e);
    }
}
export async function authVerify(code) {
    if (!currentUser) {
        return;
    }
    let requestJson = {
        'userId': currentUser.id,
        'token': code,
        'device': navigator.userAgent,
    };
    try {
        await rpcCall('auth.verify', requestJson);
        lastRefreshDate = new Date();
        await getInfo();
        invokeOnLogin();
    }
    catch (e) {
        console.log(e);
    }
}
export async function loginThirdParty(token, provider) {
    if (currentUser) {
        return;
    }
    let requestJson = {
        'token': token,
        'provider': provider,
        'device': navigator.userAgent,
    };
    try {
        await rpcCall('auth.thirdParty', requestJson);
        lastRefreshDate = new Date();
        await getInfo();
        invokeOnLogin();
    }
    catch (e) {
        console.log(e);
    }
}
export async function getInfo() {
    await refreshIfNeeded();
    try {
        currentUser = await rpcCall('auth.info');
        window.localStorage.setItem('userId', currentUser.id);
        if (!currentUser.settings)
            currentUser.settings = {};
    }
    catch (e) {
        console.log(e);
        currentUser = null;
        throw e;
    }
}
async function refreshIfNeeded() {
    let diffMs = +(new Date()) - +lastRefreshDate;
    let mins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
    if (mins < 58) {
        return;
    }
    await refresh();
}
async function refresh() {
    let userId = window.localStorage.getItem('userId');
    if (!userId) {
        return;
    }
    let refreshToken = window.localStorage.getItem('refreshToken');
    if (!refreshToken) {
        return;
    }
    let requestJson = {
        'userId': userId,
        'refreshToken': refreshToken,
    };
    try {
        await rpcCall('auth.refresh', requestJson);
    }
    catch (e) {
        console.log(`Refresh error: ${e}`);
        currentUser = null;
    }
}
export async function logout() {
    if (!currentUser) {
        return;
    }
    try {
        await refreshIfNeeded();
        await rpcCall('auth.logout');
    }
    catch (e) {
        console.log(e);
    }
    currentUser = null;
    window.localStorage.removeItem('userId');
    rpcClearAuth();
    invokeOnLogin();
}
let onLoginListeners = [];
export function invokeOnLogin() {
    for (let f of onLoginListeners) {
        f();
    }
}
export function onLogin(f, immediate = false) {
    if (isLoggedIn() || immediate) {
        f();
    }
    if (!onLoginListeners.includes(f)) {
        onLoginListeners.push(f);
    }
}
export function wasLoggedIn() {
    return window.localStorage.getItem('userId') != null;
}
let openAuthDelegate;
export function setOpenAuth(delegate) {
    openAuthDelegate = delegate;
}
export function openAuth() {
    if (openAuthDelegate) {
        openAuthDelegate();
    }
}
